/**
 * Chummys actual size — <chummys-size>
 * The scene is drawn in CSS millimetres and composed to fit any screen wider
 * than a bank card at true size. If the screen is narrower than that (rare),
 * the whole scene scales down together and says so. Any calibration a
 * visitor once saved is forgotten: there is nothing to nudge.
 */
(() => {
  class ChummysSize extends HTMLElement {
    connectedCallback() {
      try { localStorage.removeItem('chummys:mm-scale'); } catch (e) { /* private window */ }
      this.stage = this.querySelector('.chummys-size__stage');
      this.scene = this.querySelector('[data-scene]');
      this.note = this.querySelector('[data-fitnote]');
      // a measured width beats a weight; otherwise same depth ⇒ area follows weight
      const ours = Number(this.dataset.grams) || 90, theirs = Number(this.dataset.rival) || 0;
      const oursMM = Number(getComputedStyle(this).getPropertyValue('--cz-square')) || 65;
      const theirsMM = Number(this.dataset.rivalMm) || 0;
      if (theirsMM > 0) this.style.setProperty('--cz-rival', String((theirsMM / oursMM).toFixed(3)));
      else if (theirs > 0) this.style.setProperty('--cz-rival', String(Math.sqrt(theirs / ours).toFixed(3)));
      this.fit();
      if (window.ResizeObserver && this.stage) new ResizeObserver(() => this.fit()).observe(this.stage);
      window.addEventListener('resize', () => this.fit(), { passive: true });
      window.addEventListener('load', () => this.fit(), { once: true });
    }
    fit() {
      if (!this.scene || !this.stage) return;
      this.style.setProperty('--cz-fit', '1');
      const need = this.scene.offsetWidth, have = this.stage.clientWidth;
      const s = need > have ? Math.max(0.6, have / need) : 1;
      this.style.setProperty('--cz-fit', s.toFixed(3));
      // a scaled scene keeps its unscaled box; pull the slack back in
      this.scene.style.marginTop = s < 1 ? `${-(1 - s) * this.scene.offsetHeight}px` : '';
      if (this.note) {
        if (s < 0.985) { this.note.hidden = false; this.note.textContent = `Your screen is narrower than a bank card, so the whole scene is shown at ${Math.round(s * 100)}% — the card included.`; }
        else this.note.hidden = true;
      }
    }
  }
  if (!customElements.get('chummys-size')) customElements.define('chummys-size', ChummysSize);
})();
